









































































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import {Customer} from '@/entity/Customer';
import {Validation} from '@/utils/Validation';
import {SecurityUtils} from '@/oauth/SecurityUtils';
import {CustomerDto} from '@/dto/CustomerDto';
import PCCS from '@/static/city.json';
import {CustomerBankDto} from "@/dto/CustomerBankDto";
import {CustomerBank} from "@/entity/CustomerBank";
import XHeader from "@/views/KeShangAdmin/XHeader.vue";
import Footer from "@/views/KeShangAdmin/Footer.vue";
import {getModule} from "vuex-module-decorators";
import {CustomerStore} from "@/store/CustomerStore";
import {AuthStore} from "@/oauth/AuthStore";
import {AuthTokenDto} from "@/oauth/AuthTokenDto";
import {CollectCompany} from "@/entity/CollectCompany";


@Component({
  components: {Footer, XHeader},
})
export default class EditCustomer extends Vue {
  step = 1;
  v = Validation;
  customer = new Customer();
  customerBank = new CustomerBank();
  nameList: string[] = [];
  shape = '';
  nations: string[] = ["美国", "日本", "新加坡", "英国", "法国",];
  currencys: string[] = ["人民币", "美元", "日元", "新元", "欧元"];
  provinces: string[] = [];
  citys: string[] = [];
  districts: string[] = [];
  tab = 'gs';
  private customers: Customer[] = [];
  isAdminOpen = false;
  cs = getModule(CustomerStore);
  ls = getModule(AuthStore);
  su = SecurityUtils;
  rightDrawerOpen = true;
  drawer = false;
  tabs = 'group_add'
  collectCompany = new CollectCompany()

  getChineseByIsViewPass(b: boolean | null) {
    if (b != null) {
      return b ? '已通过' : '未通过';
    }
    return "未审核";
  }

  async deleteCustomer(customer: Customer) {
    const nf = this.$q.notify({type: 'ongoing', message: '正在处理...', timeout: 0});
    try {
      await CustomerDto.delete(customer.id as number)
      // await this.$router.push({name: 'KeShangSelect'});
      this.$router.go(-1)
      nf({type: 'positive', message: '完成', timeout: 1500});
    } catch (e) {
      nf({type: 'negative', message: '错误:' + e, timeout: 2500});
    }

  }

  keShangSelect() {
    this.$router.push({name: 'KeShangSelect'});
  }


  get currentName() {
    // return this.cs.currentCustomer.name;
    return this.collectCompany.companyName;
  }

  keShangSelect1() {
    this.$router.push({name: 'keShangSelect1'});
  }

  keShangSelect2() {
    this.$router.push({name: 'keShangSelect2'});
  }

  toCustomerAdminTable() {
    this.$router.push({name:'CustomerAdminTable'})
  }


  goToZiZhangHaoGuanLi() {
    this.$router.push({name: 'ZiZhangHao'});
  }


  saveCompany() {
    sessionStorage.setItem("name", this.cs.currentCustomer.name)
  }

  isDialogShow = false;

  companyName() {
    const item: string | null = sessionStorage.getItem("name");
    if (item == null) {
      return "home"
    }
    return item;
  }

  get userName() {
    return this.ls.loginUser.username
  }


  toggleRightDrawer() {
    this.rightDrawerOpen = !this.rightDrawerOpen;
  }

  toZiZhangHao() {
    this.$router.push({name:'ZiZhangHao'})
  }


  async findAll() {
    const id = this.su.getLoginUser().id as number;
    const customer = new Customer();
    customer.creatorId = id;
    this.customers = await CustomerDto.findAll(customer);
    for (const value of this.su.getLoginUser().authorities) {
      if (value.authority.startsWith('ROLE_CUSTOMER_')) {
        const id = Number(value.authority.replace('ROLE_CUSTOMER_', '').replace('_ADMIN', ''));
        if (!this.customers.some(c => c.id === id)) {
          const customer = await CustomerDto.findById(id);
          if (typeof customer !== 'undefined') {
            this.customers.push(customer);
          }
        }
      }
    }
  }


  suc() {
    AuthTokenDto.logout();
    this.$router.push({name: 'login'});
  }

  handleClick(c: Customer) {
    getModule(CustomerStore).setCurrentCustomer(c);
    this.rightDrawerOpen = !this.rightDrawerOpen;

    this.saveCompany();
    // const id = c.id + '';
    // this.$router.push({name: 'KeShangMain', params: {id: id}});
  }

  get customerName() {
    return this.cs.currentCustomer.name;
  }


  initProvinces() {
    this.provinces = [];
    for (const provinceKey in PCCS) {
      this.provinces[provinceKey] = PCCS[provinceKey].provinceName;
    }
  }


  initCitys() {
    this.citys = [];
    for (const provinceKey in PCCS) {
      if (PCCS[provinceKey].provinceName === this.customer.province) {
        for (const cityKey in PCCS[provinceKey].mallCityList) {
          this.citys[cityKey] = PCCS[provinceKey].mallCityList[cityKey].cityName;
        }
        break;
      }
    }
  }

  initDistrict() {
    this.districts = [];
    for (const provinceKey in PCCS) {
      if (PCCS[provinceKey].provinceName === this.customer.province) {
        for (const cityKey in PCCS[provinceKey].mallCityList) {
          if (PCCS[provinceKey].mallCityList[cityKey].cityName === this.customer.city) {
            for (const districtKey in PCCS[provinceKey].mallCityList[cityKey].mallAreaList) {
              this.districts[districtKey] = PCCS[provinceKey].mallCityList[cityKey].mallAreaList[districtKey].areaName;
            }
            break;
          }
        }
      }
    }
  }

  countrySet() {
    if (this.shape === '国内') {
      this.customer.country = 1;
      this.customer.nation = '中国';
    } else {
      this.customer.country = 0;
    }
  }

  // handleUpload(e: { xhr: XMLHttpRequest }) {
  //   this.customer.businessLicense = e.xhr.responseText;
  // }

  handleUpload(e: { xhr: XMLHttpRequest }) {
    // this.customer.businessLicense = e.xhr.responseText;
    const  url =e.xhr.responseText
    const  url1 = url.replace("http","https")
    const  url2 = url1.replace("ygpubfile.yong-gang.cn:80","ygpubfile.yong-gang.cn")
    // console.dir(url2)
    this.customer.businessLicense = url2;
  }

  // handleLicense(e: { xhr: XMLHttpRequest }) {
  //   this.customer.licenseAttachment = e.xhr.responseText;
  // }

  handleLicense(e: { xhr: XMLHttpRequest }) {
    // this.customer.licenseAttachment = e.xhr.responseText;
    // console.log(e.xhr.responseText)
    const  url = e.xhr.responseText
    const  url1 = url.replace("http","https")
    const  url2 = url1.replace("ygpubfile.yong-gang.cn:80","ygpubfile.yong-gang.cn")
    this.customer.licenseAttachment = url2

  }

  async save() {
    const nf = this.$q.notify({type: 'ongoing', message: '正在处理...', timeout: 0});
    try {
      for (let i = 0; i < this.customer.customerBankList.length; i++) {
        const customerBank: CustomerBank = await CustomerBankDto.save(this.customer.customerBankList[i]);
        this.customer.customerBankList[i] = customerBank;
      }

      await CustomerDto.save(this.customer);
      await this.$router.push({name: 'KeShangSelect'});
      nf({type: 'positive', message: '完成', timeout: 1500});
    } catch (e) {
      nf({type: 'negative', message: '错误:' + e, timeout: 2500});
    }
  }

  async saveBank() {
    const customerBank1 = new CustomerBank();
    this.customer.customerBankList.push(customerBank1);
  }


  nameNotExist(i: string) {
    if (this.nameList.some(value => value === i)) {
      return '名称已被占用';
    }
    return true;
  }

  async updateNameList() {
    const customers = await CustomerDto.findAll(new Customer());
    customers.forEach(value => {
      this.nameList.push(value.name);
    });
  }

///潘大帅做的！！！！！很猛

  async getById(id = this.id) {
    this.customer = await CustomerDto.findById(Number(id));
    // this.customer.businessLicense = "http://ygpubfile.yong-gang.cn:80/f/23e8b94d-0643-4533-870e-e93fe424a7ad.jpg";
  }

  get id() {
    return this.$route.params.id;
  }

///
  async getId(idd = this.id) {
    this.customerBank = await CustomerBankDto.findById(Number(idd));
  }


  private mounted() {
    this.customer.creatorId = SecurityUtils.getLoginUser().id as number;
    this.updateNameList();
    this.getById();
    this.getId();
    this.initProvinces();
    return;
  }
}
